<template>
    <footer id="footer">
        <main-container class="mt-0 mb-0">
            <section class="footer_top">
                <div class="footer_container">
                    <div class="footer_box d-flex flex-column">
                        <h3>
                            <router-link :to="{ name: 'help' }">
                                Помощь
                            </router-link>
                        </h3>

                        <router-link :to="{ name: 'help' }">
                            Оплата
                        </router-link>
                        <router-link
                            :to="{
                                name: 'helpSecond',
                                params: {
                                    id: 'delivery'
                                }
                            }"
                        >
                            Доставка
                        </router-link>
                        <router-link
                            :to="{
                                name: 'helpSecond',
                                params: {
                                    id: 'gauranties'
                                }
                            }"
                        >
                            Гарантия
                        </router-link>

                        <router-link
                            :to="{
                                name: 'helpSecond',
                                params: {
                                    id: 'return'
                                }
                            }"
                        >
                            Возврат товара
                        </router-link>

<!--                        <router-link-->
<!--                            :to="{-->
<!--                                name: 'helpSecond',-->
<!--                                params: {-->
<!--                                    id: 'credit'-->
<!--                                }-->
<!--                            }"-->
<!--                        >-->
<!--                            Кредит-->
<!--                        </router-link>-->
                    </div>

                    <div class="footer_box">
                        <h3>
                            <a href.prevent="/">
                                Информация
                            </a>
                        </h3>

                        <router-link :to="{ name: 'allbrands' }">
                            Бренды
                        </router-link>

                        <a
                            href="https://forms.gle/6GRdsBnz85JPciSP9"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Партнёрам
                        </a>

                        <router-link :to="{ name: 'oferta' }">
                            Публичная оферта
                        </router-link>

                        <router-link
                            :to="{
                                name: 'faq'
                            }"
                        >
                            FAQ
                        </router-link>
                    </div>

                    <div class="footer_box">
                        <h3>
                            <a href.prevent="/">
                                Компания
                            </a>
                        </h3>
                        <router-link :to="{ name: 'aboutus' }">
                            О нас
                        </router-link>
                    </div>

                    <div class="footer_box">
                        <h3>
                            <router-link :to="{ name: 'contacts' }">
                                Контакты
                            </router-link>
                        </h3>
                        <a href="tel:+998773335000">
                            +998 77 333 50 00
                        </a>
                        <router-link :to="{ name: 'contacts' }">
                            Toshkent, Islom Karimov koʻchasi, 1
                        </router-link>
                        <router-link :to="{ name: 'contacts' }">
                            info@buum.uz
                        </router-link>
                    </div>
                </div>
            </section>

            <div class="footer_border"></div>

<!--            <section class="footer_bottom">-->
<!--                <div class="footer_container">-->
<!--                    <div class="footer_box">-->
<!--                        <h6>-->
<!--                            Мобильное приложение:-->
<!--                        </h6>-->
<!--                    </div>-->
<!--                    <div class="footer_box">-->
<!--                        <div class="png_box apple">-->
<!--                            <a-->
<!--                                href="https://apps.apple.com/app/Buum/id6444784268"-->
<!--                                target="_blank"-->
<!--                                rel="nofollow"-->
<!--                            >-->
<!--                                <img src="https://buum.uz/resources/assets/image/appstore.jpg" style="height: 40px" alt="appstore">-->
<!--                            </a>-->
<!--                        </div>-->
<!--                        <div class="png_box google">-->
<!--                            <a-->
<!--                                href="https://play.google.com/store/apps/details?id=com.Buum.sqb.uz.Buum"-->
<!--                                target="_blank"-->
<!--                                rel="nofollow"-->
<!--                            >-->
<!--                                <img src="https://buum.uz/resources/assets/image/playmarket.jpg" style="height: 40px" alt="playmarket">-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="footer_box">-->
<!--                        <h6>-->
<!--                            Мы в соц.сетях:-->
<!--                        </h6>-->

<!--                        <a href="https://t.me/Buumsupport" rel="nofollow">-->
<!--                            <svg-->
<!--                                width="20"-->
<!--                                height="19"-->
<!--                                viewBox="0 0 20 19"-->
<!--                                fill="none"-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                            >-->
<!--                                <path-->
<!--                                    d="M20 0L0 8.50122L5.24304 10.582L7.1095 17.5979L10.5463 14.2679L16.1375 18.1295L20 0ZM7.38184 11.4813L7.18005 13.3105L6.40503 10.397L20 0L7.38184 11.4813Z"-->
<!--                                    fill="#7A7A7A"-->
<!--                                />-->
<!--                            </svg>-->
<!--                        </a>-->

<!--                        <a-->
<!--                            href="https://www.instagram.com/buum.uz/"-->
<!--                            rel="nofollow"-->
<!--                        >-->
<!--                            <svg-->
<!--                                width="20"-->
<!--                                height="20"-->
<!--                                viewBox="0 0 20 20"-->
<!--                                fill="none"-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                            >-->
<!--                                <path-->
<!--                                    d="M14.0655 10C14.0655 12.2456 12.2451 14.0659 9.99952 14.0659C7.75393 14.0659 5.93359 12.2456 5.93359 10C5.93359 7.75442 7.75393 5.93408 9.99952 5.93408C12.2451 5.93408 14.0655 7.75442 14.0655 10Z"-->
<!--                                    fill="#7A7A7A"-->
<!--                                />-->
<!--                                <path-->
<!--                                    d="M19.5089 2.80602C19.3135 2.27639 19.0017 1.797 18.5965 1.4035C18.203 0.998331 17.7239 0.686514 17.194 0.491062C16.7642 0.324133 16.1185 0.12544 14.9293 0.0713093C13.6428 0.0126412 13.2571 0 10.0002 0C6.74295 0 6.35723 0.0123171 5.07107 0.0709852C3.88182 0.12544 3.23582 0.324133 2.80635 0.491062C2.27639 0.686514 1.797 0.998331 1.40382 1.4035C0.998655 1.797 0.686839 2.27606 0.491062 2.80602C0.324133 3.23582 0.12544 3.88182 0.0713093 5.07107C0.0126412 6.35723 0 6.74295 0 10.0002C0 13.2571 0.0126412 13.6428 0.0713093 14.9293C0.12544 16.1185 0.324133 16.7642 0.491062 17.194C0.686839 17.7239 0.998331 18.203 1.4035 18.5965C1.797 19.0017 2.27606 19.3135 2.80602 19.5089C3.23582 19.6762 3.88182 19.8749 5.07107 19.929C6.35723 19.9877 6.74262 20 9.99984 20C13.2574 20 13.6431 19.9877 14.9289 19.929C16.1182 19.8749 16.7642 19.6762 17.194 19.5089C18.2578 19.0986 19.0986 18.2578 19.5089 17.194C19.6759 16.7642 19.8746 16.1185 19.929 14.9293C19.9877 13.6428 20 13.2571 20 10.0002C20 6.74295 19.9877 6.35723 19.929 5.07107C19.8749 3.88182 19.6762 3.23582 19.5089 2.80602ZM10.0002 16.2634C6.54069 16.2634 3.73629 13.4593 3.73629 9.99984C3.73629 6.54036 6.54069 3.73629 10.0002 3.73629C13.4593 3.73629 16.2637 6.54036 16.2637 9.99984C16.2637 13.4593 13.4593 16.2634 10.0002 16.2634ZM16.5114 4.95243C15.703 4.95243 15.0476 4.29704 15.0476 3.48865C15.0476 2.68026 15.703 2.02486 16.5114 2.02486C17.3197 2.02486 17.9751 2.68026 17.9751 3.48865C17.9748 4.29704 17.3197 4.95243 16.5114 4.95243Z"-->
<!--                                    fill="#7A7A7A"-->
<!--                                />-->
<!--                            </svg>-->
<!--                        </a>-->

<!--                        <a-->
<!--                            href="https://www.facebook.com/buum.uz"-->
<!--                            rel="nofollow"-->
<!--                        >-->
<!--                            <svg-->
<!--                                width="20"-->
<!--                                height="20"-->
<!--                                viewBox="0 0 20 20"-->
<!--                                fill="none"-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                            >-->
<!--                                <path-->
<!--                                    d="M14.9996 0.00416134L12.406 0C9.49227 0 7.60926 1.9319 7.60926 4.92203V7.19141H5.00156C4.77622 7.19141 4.59375 7.37409 4.59375 7.59943V10.8875C4.59375 11.1128 4.77643 11.2953 5.00156 11.2953H7.60926V19.5922C7.60926 19.8175 7.79174 20 8.01707 20H11.4194C11.6447 20 11.8272 19.8173 11.8272 19.5922V11.2953H14.8762C15.1015 11.2953 15.284 11.1128 15.284 10.8875L15.2853 7.59943C15.2853 7.49123 15.2422 7.38762 15.1658 7.31105C15.0895 7.23448 14.9854 7.19141 14.8772 7.19141H11.8272V5.26763C11.8272 4.34298 12.0475 3.87358 13.252 3.87358L14.9992 3.87295C15.2243 3.87295 15.4068 3.69027 15.4068 3.46514V0.411972C15.4068 0.187052 15.2245 0.00457747 14.9996 0.00416134Z"-->
<!--                                    fill="#7A7A7A"-->
<!--                                />-->
<!--                            </svg>-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </section>-->
        </main-container>
    </footer>
</template>

<script>
import MainContainer from "../components/UI/MainContainer";

export default {
    components: { MainContainer }
};
</script>

<style lang="scss" scoped>
footer {
    margin-top: 30px;
    background-color: #f2f2f3;
    position: relative;
}

.footer_top {
    padding: 40px 0;

    .footer_container {
        display: flex;
        justify-content: space-between;

        .footer_box {
            display: flex;
            flex-direction: column;

            h3 {
                a {
                    font-family: Acrom-Bold, sans-serif;
                    font-size: 20px;
                    line-height: 150%;
                    /* identical to box height, or 30px */

                    /* black */

                    color: #0a0a0a !important;
                }
            }

            a {
                margin: 10px 0;

                font-family: Acrom-Medium, sans-serif;
                font-size: 15px;
                line-height: 18px;
                /* identical to box height */

                /* grey_main */

                color: #7a7a7a !important;
            }
        }
    }
}

.footer_border {
    border-top: 1px solid #e9e9e9;
    position: absolute;
    bottom: 123px;
    left: 0;
    right: 0;
}

.footer_bottom {
    padding: 30px 0;

    .footer_container {
        display: flex;
        justify-content: center;
        align-items: center;

        .footer_box {
            display: flex;
            align-items: center;

            .png_box {
                display: flex;
                justify-content: center;
                align-items: center;

                a {
                    margin: 0;
                }
            }

            a,
            h6 {
                font-family: Acrom-Medium, sans-serif;
                font-size: 16px;
                line-height: 1;
                /* identical to box height, or 24px */

                /* grey_main */

                color: #7a7a7a;

                margin: 0 10px;
            }

            a:hover {
                svg {
                    path {
                        fill: #363f4d;
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 992px) {
    .footer_top {
        .footer_container {
            justify-content: space-between;
            padding: 0px 30px;

            .footer_box {
                a {
                    max-width: 230px;
                }
            }
        }
    }
}

@media only screen and (max-width: 768px) {
    .footer_top {
        .footer_container {
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 10px 10px 10px;

            .footer_box {
                margin-bottom: 10px;

                h3 {
                    a {
                        font-size: 16px;
                    }
                }

                a {
                    max-width: 230px;
                    font-size: 14px;
                }
            }
        }
    }

    .footer_border {
        bottom: 212px;
    }

    .footer_bottom {
        .footer_container {
            flex-direction: column;
            padding: 10px 0;
            justify-content: start;

            .footer_box {
                .png_box {
                    margin: 10px 0 20px;
                }

                a {
                    margin: 0 7px;
                }

                h6 {
                    margin: 0 5px;
                }
            }
        }
    }
}

@media only screen and (max-width: 630px) {
    .footer_top {
        .footer_container {
            padding: 10px 5px 5px;
            .footer_box {
                a {
                    max-width: 155px;
                }
            }
        }
    }
}

@media screen and (max-width: 395px) {
    .footer_top {
        .footer_container {
            justify-content: space-evenly;
            .footer_box {
                width: 45%;

                a {
                    word-break: break-word;
                }
            }
        }
    }

    .footer_border {
        bottom: 258px;
    }

    .footer_bottom {
        padding-top: 0;
        padding-bottom: 80px;
    }
}
</style>
